var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyright = function SvgCopyright(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--c-basic-black)",
    d: "M7.969 0a7.969 7.969 0 1 0 7.969 7.969A7.98 7.98 0 0 0 7.968 0m0 15A7.031 7.031 0 1 1 15 7.969 7.04 7.04 0 0 1 7.969 15M5.312 7.969a2.656 2.656 0 0 0 4.782 1.593.469.469 0 1 1 .75.564 3.595 3.595 0 1 1 0-4.314.47.47 0 0 1-.75.563 2.657 2.657 0 0 0-4.781 1.594"
  })));
};
export default SvgCopyright;